import React from "react";
//PrimeReact Components
import * as pr from "../../../common/PrimeComponents";
import { CrudlStatus } from "../../../common/config/AppConstants";
import { BPMInput } from "../../Common/BPMInput";
import * as format from "../../../common/FormatFunctions";
import { ListValueGenerator } from "../../Common/ListValueGenerator";
import { LoadScreen } from "../../Common/LoadScreen";
import { FileUploader } from "../../Common/FileUploader";
import { FlowItemDisplay } from "./FlowItemDisplay";
import * as Storage from "../../../common/config/Storage";
import { BPMPartProductJson } from "../../Common/BPMPartProductJson";
export class FlowItemCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentFlowItem: {}
    };
  }

  updateCurrentFlowItem = (field, value) => {
    this.props.updateValue(field, value);
  };

  updateCurrentFlowItemFiles = files => {
    this.updateCurrentFlowItem("fileUrls", files);
  };

  checkRequiredFields = () => {
    //TODO IMPLEMENT
  };

  render() {
    return (
      <React.Fragment>
        <pr.ScrollPanel
          ref={el => (this.layoutMenuScroller = el)}
          style={{ height: "85%", borderColor: "transparent" }}
        >
          <div className="ui-g">
            <h2>
              {format.capitalize(this.props.crudlState.display) + " Operation"}
            </h2>
            <div className="ui-g-12"></div>
            {this.props.loading === true && <LoadScreen />}
            {this.props.loading !== true && (
              <React.Fragment>
                <div className="ui-g-1"></div>
                <div className="ui-g-5">
                  <div className="ui-g-12">
                    <div className="ui-g-3">
                      <label className="input-label">Name *</label>
                    </div>

                    <div className="ui-g-9">
                      <pr.InputText
                        required={true}
                        value={this.props.editedObject.name}
                        onChange={e =>
                          this.updateCurrentFlowItem("name", e.target.value)
                        }
                        disabled={this.props.crudlState === CrudlStatus.VIEW}
                      />
                    </div>
                  </div>
                  {/* <div className="ui-g-12">
                    <div className="ui-g-3">
                      <label className="input-label">Description *</label>
                    </div>

                    <div className="ui-g-9">
                      <pr.InputText
                        required={true}
                        value={this.props.editedObject.description}
                        onChange={e =>
                          this.updateCurrentFlowItem(
                            "description",
                            e.target.value
                          )
                        }
                        disabled={this.props.crudlState === CrudlStatus.VIEW}
                      />
                    </div>
                  </div> */}
                  <div className="ui-g-12">
                    <div className="ui-g-3">
                      <label className="input-label">Notes</label>
                    </div>

                    <div className="ui-g-9">
                      <textarea
                        id={this.props.editedObject.notes + " Details"}
                        rows={5}
                        placeholder=""
                        value={this.props.editedObject.notes}
                        onChange={e => {
                          this.updateCurrentFlowItem("notes", e.target.value);
                        }}
                        disabled={this.props.crudlState === CrudlStatus.VIEW}
                        style={{
                          width: "100%",
                          backgroundColor: "transparent"
                        }}
                      />
                    </div>
                  </div>
                  <div className="ui-g-12">
                    <div className="ui-g-3">
                      <label className="input-label">Station</label>
                    </div>

                    <div className="ui-g-9">
                      <pr.Dropdown
                        value={this.props.editedObject.toolId || ""}
                        options={this.props.stationMap}
                        onChange={e => {
                          this.updateCurrentFlowItem("toolId", e.value);
                        }}
                        filter={true}
                        filterBy="label"
                        filterPlaceholder="Search"
                        style={{ width: "100%" }}
                      />
                    </div>
                  </div>
                  <div className="ui-g-12">
                    <label className="input-label">
                      Upload Standard Operating Procedures to complete this
                      Operation
                    </label>
                    <FileUploader
                      fileType="FILE"
                      label="Upload"
                      header={"SOP's"}
                      accept=".doc,.pdf,.docx,.xls"
                      currentFiles={this.props.editedObject.fileUrls}
                      field={"fileUrls"}
                      updateFiles={this.updateCurrentFlowItem}
                    />
                  </div>
                </div>
                <div className="ui-g-5">
                  <div className="ui-g-12">
                    <ListValueGenerator
                      title="Optional Workflow Status"
                      header="Enter Status"
                      propertyPrefix="Status :"
                      listProperties={this.props.editedObject.statusList}
                      listField="statusList"
                      updateBean={this.updateCurrentFlowItem}
                      capitalize={true}
                      defaults={true}
                      allowDefaultDelete={false}
                      includeSequence={true}
                      defaultValues={Storage.parseFlowItemStatusOptions()}
                    />
                  </div>
                </div>

                <div className="ui-g-1"></div>

                <div className="ui-g-1"></div>
                {this.props.type === "PRODUCT" && (
                  <React.Fragment>
                    <div className="ui-g-5">
                      <BPMPartProductJson
                        type="DROPDOWN"
                        title="Select Inputs"
                        optionLabel="name"
                        header="Select Component"
                        propertyPrefix="Input :"
                        listProperties={
                          this.props.editedObject.inputComponentList
                        }
                        selectionOptions={pr.getDropdownOptionsExtension(
                          this.props.componentList,
                          "name",
                          "name"
                        )}
                        listField="inputComponentList"
                        updateBean={this.updateCurrentFlowItem}
                      />
                    </div>
                    <div className="ui-g-5">
                      {/*
                  <BPMPartProductJson
                    type="DROPDOWN"
                    title="Select Outputs"
                    optionLabel="name"
                    header="Select Component"
                    propertyPrefix="Output :"
                    listProperties={this.props.editedObject.outputComponentList}
                    selectionOptions={pr.getDropdownOptionsExtension(
                      this.props.componentList,
                      "name",
                      "name"
                    )}
                    listField="outputComponentList"
                    updateBean={this.updateCurrentFlowItem}
                  />*/}
                    </div>
                  </React.Fragment>
                )}
                <div className="ui-g-1"></div>

                <div className="ui-g-1"></div>
                <div className="ui-g-5"></div>
                <div className="ui-g-5"></div>
                <div className="ui-g-1"></div>
              </React.Fragment>
            )}
          </div>
        </pr.ScrollPanel>
        <div className="Container">
          <pr.Toolbar
            className="bottom-bar"
            style={{
              backgroundColor: "transparent",
              borderColor: "transparent"
            }}
          >
            <div className="p-toolbar-group-left">
              <pr.Button
                icon="pi pi-times"
                label={"Cancel"}
                className="p-button-danger"
                style={{
                  marginRight: ".25em",
                  float: "left",
                  backgroundColor: "#043066"
                }}
                onClick={() => {
                  this.props.closeFlowItem();
                }}
              />
              <pr.Button
                icon={
                  this.props.loading === true
                    ? "pi pi-spin pi-spinner"
                    : "pi pi-trash"
                }
                label={"Delete"}
                onClick={() => {
                  this.props.deleteFlowItem();
                }}
                style={
                  this.props.crudlState !== CrudlStatus.CREATE &&
                  this.props.crudlState !== CrudlStatus.VIEW
                    ? {
                        marginRight: ".25em",
                        float: "right",
                        backgroundColor: "#043066"
                      }
                    : { display: "none" }
                }
              />
              <pr.Button
                disabled={this.checkRequiredFields()}
                icon={
                  this.props.loading === true
                    ? "pi pi-spin pi-spinner"
                    : "pi pi-save"
                }
                label={"Save"}
                onClick={e => {
                  this.props.saveFlowItem();
                }}
                style={
                  this.props.crudlState !== CrudlStatus.VIEW
                    ? {
                        marginRight: ".25em",
                        float: "right",
                        backgroundColor: "#043066"
                      }
                    : { display: "none" }
                }
              />
              {/* <pr.Button
                disabled={this.checkRequiredFields()}
                icon={
                  this.props.loading === true
                    ? "pi pi-spin pi-spinner"
                    : "pi pi-save"
                }
                label={"Save and Close"}
                onClick={() => {
                  this.props.crudlExecute(false);
                }}
                style={
                  this.props.crudlState !== CrudlStatus.VIEW
                    ? {
                        marginRight: ".25em",
                        float: "right",
                        backgroundColor: "#043066"
                      }
                    : { display: "none" }
                }
              /> */}
            </div>
          </pr.Toolbar>
        </div>
      </React.Fragment>
    );
  }

  attributeListToFields = () => {
    let componentArray = [];
    let i = 0;
    console.log(this.props.selectedAttributeSet);
    if (this.props.selectedAttributeSet !== undefined) {
      if (this.props.selectedAttributeSet.attributeBeanList !== undefined) {
        this.props.selectedAttributeSet.attributeBeanList.forEach(e => {
          if (e.type === "LIST") {
            componentArray[i] = (
              <div className="ui-g-12" key={i}>
                <div className="ui-g-3">
                  <label className="input-label">{e.name}</label>
                </div>
                <div className="ui-g-9">
                  <pr.Dropdown
                    value={
                      JSON.parse(this.props.editedObject.customPropertiesJson)[
                        e.name
                      ] || ""
                    }
                    options={pr.getDropdownOptionsFromList(e.acceptedValues)}
                    onChange={f => {
                      this.props.updateAttributeProperties(e.name, f.value);
                    }}
                    filter={true}
                    filterBy="label"
                    filterPlaceholder="Search"
                    style={{ width: "100%" }}
                  />
                </div>
                {/* <div className="ui-g-12 ui-md-4" style={{ paddingTop: "2em" }}>
                
                  {this.props.editedObject.operationalType === "CONFIGURABLE" && (
                    <div className="p-col-12">
                      <pr.Checkbox
                        inputId="cb1"
                        checked={this.state.attributeConfigurable[e.name]}
                        onChange={f => {
                          this.updateConfigList(e.name, f.checked);
                        }}
                      />
                      <label htmlFor="cb1" className="p-checkbox-label">
                        Configurable?
                      </label>
                    </div>
                  )}
                  {this.props.editedObject.operationalType === "VARIABLE" && (
                    <div className="p-col-12">
                      <pr.Checkbox
                        inputId="cb1"
                        checked={this.state.attributeVariable[e.name].checked}
                        onChange={f => {
                          this.updateVariableList(e.name, f.checked);
                        }}
                      />
                      <label htmlFor="cb1" className="p-checkbox-label">
                        Variable?
                      </label>
                    </div>
                  )}
                </div> */}
              </div>
            );
          }

          if (e.type === "INPUT") {
            componentArray[i] = (
              <div className="ui-g-12" key={i}>
                <div className="ui-g-3">
                  <label className="input-label">{e.name}</label>
                </div>
                <div className="ui-g-9">
                  <pr.InputText
                    id={e.name + " Attribute"}
                    value={
                      JSON.parse(this.props.editedObject.customPropertiesJson)[
                        e.name
                      ] || ""
                    }
                    onChange={f => {
                      this.props.updateAttributeProperties(
                        e.name,
                        f.target.value
                      );
                    }}
                  />
                </div>
                {/* <div className="ui-g-12 ui-md-4" style={{ paddingTop: "2em" }}>
                  <b>{e.unitOfMeasurement || ""}</b>
                </div> */}
                {/* <div className="ui-g-12 ui-md-4" style={{ paddingTop: "2em" }}>
        
                  {s.editedPart.operationalType === "CONFIGURABLE" && (
                    <div className="p-col-12">
                      <pr.Checkbox
                        inputId="cb1"
                        checked={this.state.attributeConfigurable[e.name]}
                        onChange={f => {
                          this.updateConfigList(e.name, f.checked);
                        }}
                      />
                      <label htmlFor="cb1" className="p-checkbox-label">
                        Configurable?
                      </label>
                    </div>
                  )}
                  {s.editedPart.operationalType === "VARIABLE" && (
                    <div className="p-col-12">
                      <pr.Checkbox
                        inputId="cb1"
                        checked={this.state.attributeVariable[e.name].checked}
                        onChange={f => {
                          this.updateVariableList(e.name, f.checked);
                        }}
                      />
                      <label htmlFor="cb1" className="p-checkbox-label">
                        Variable?
                      </label>

                      {this.state.attributeVariable[e.name] && (
                        <div className="ui-g-12">
                          {this.getAcceptedValues(e.name)}
                        </div>
                      )}
                    </div>
                  )}
                </div> */}
              </div>
            );
          }

          i++;
        });
      }
    }

    return componentArray;
  };
}



// WEBPACK FOOTER //
// ./src/components/Flows/UI/FlowItemCard.js